/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type UseSchedules_ScheduleFragment = { __typename: 'Schedule', id: string, title: string };

export type UseSchedules_DisplayFragment = { __typename: 'Display', id: string, schedule?: { __typename: 'DisplaySchedule', isSynced?: boolean | null, schedule?: { __typename: 'Schedule', id: string, title: string } | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string, scheduleId?: string | null } | { __typename: 'ScheduleUpdateCompleted', id: string, scheduleId?: string | null } | { __typename: 'ScheduleUpdateInProgress', id: string, scheduleId?: string | null } | { __typename: 'ScheduleUpdateRejected', rejectionCode: string, id: string, scheduleId?: string | null } | null } | null };

export const UseSchedules_ScheduleFragmentDoc = gql`
    fragment UseSchedules_schedule on Schedule {
  id
  title
}
    `;
export const UseSchedules_DisplayFragmentDoc = gql`
    fragment UseSchedules_display on Display {
  id
  schedule {
    schedule {
      id
      ...UseSchedules_schedule
    }
    isSynced
    latestJob {
      __typename
      id
      scheduleId
      ... on ScheduleUpdateRejected {
        rejectionCode
      }
    }
  }
}
    ${UseSchedules_ScheduleFragmentDoc}`;